import { useMemo } from 'react';
import { toDecimal } from 'utils/to-decimal';
import * as Yup from 'yup';


export const useFormTransferenciaValidation = () => {


    const accordionMockValidation = useMemo(() => ([
        { campo: 'numeroInscricao', accordion: 'pagador' },
        { campo: 'razaoSocial', accordion: 'pagador' },
        { campo: 'bancoPagador', accordion: 'pagador' },
        { campo: 'codigoAgencia', accordion: 'pagador' },
        { campo: 'numeroConta', accordion: 'pagador' },
        { campo: 'codigoFornecedor', accordion: 'recebedor' },
        { campo: 'nomeFornecedor', accordion: 'recebedor' },
        { campo: 'bancoDestino', accordion: 'recebedor' },
        { campo: 'agenciaDestino', accordion: 'recebedor' },
        { campo: 'digitoAgenciaDestino', accordion: 'recebedor' },
        { campo: 'contaCorrenteDestino', accordion: 'recebedor' },
        { campo: 'nomeAgenciaDestino', accordion: 'recebedor' },
        { campo: 'tipoPagamento', accordion: 'transferencia' },
        { campo: 'dataPagamento', accordion: 'transferencia' },
        { campo: 'valorPagamento', accordion: 'transferencia' },
        { campo: 'valorAutorizado', accordion: 'transferencia' },
        { campo: 'numeroCompromissoBanco', accordion: 'transferencia' },
        { campo: 'numeroCompromissoCliente', accordion: 'transferencia' },
        { campo: 'usoEmpresa', accordion: 'transferencia' },
        { campo: 'externalId', accordion: 'transferencia' },
        { campo: 'externalCode', accordion: 'transferencia' },
    ]), [])

    const FormTransferenciaValidationYup = useMemo(() => {
        return (
            Yup.object().shape({
                codigoFornecedor: Yup.string().required('Informe o CPF ou CNPJ').typeError('Informe o CPF ou CNPJ'),
                nomeFornecedor: Yup.string().required('Informe o Nome do Recebedor').typeError('Informe o Nome do Recebedor'),
                bancoDestino: Yup.string().required('Informe o Banco de Destino').typeError('Informe o Banco de Destino'),
                agenciaDestino: Yup.string().required('Informe a Agência de Destino').typeError('Informe o Número da Agência de Destino'),
                contaCorrenteDestino: Yup.string().required('Informe a Conta Corrente de Destino').typeError('Informe a Conta Corrente de Destino'),
                nomeAgenciaDestino: Yup.string().required('Informe o Nome da Agência de Destino').typeError('Informe o Nome da Agência de Destino'),
                tipoPagamento: Yup.string().required('Informe o Tipo de Pagamento').typeError('Informe o Tipo de Pagamento'),
                dataPagamento: Yup.string().required('Informe a Data de Pagamento').typeError('Informe a Data de Pagamento'),
                valorPagamento: Yup.string().required('Informe o Valor de Pagamento').typeError('Informe o Valor de Pagamento').test({
                    name: 'valorPagamento',
                    message: 'O valor de pagamento deve ser maior que zero',
                    test: (value) => toDecimal(value) > 0,
                }),
                valorAutorizado: Yup.string().required('Informe o Valor Autorizado').typeError('Informe o Valor Autorizado').test({
                    name: 'valorAutorizado',
                    message: 'O valor autorizado deve ser maior que zero',
                    test: (value) => toDecimal(value) > 0,
                }),
            })
        )
    }, [])

    return {
        FormTransferenciaValidationYup,
        accordionMockValidation
    }
}
